import "./Chart.css";

import { useEffect, useState } from "react";

import { ComponentPlaceholder } from "../../../components/componentPlaceholder/componentPlaceholder";
import { ComponentTitle } from "../../../components/componentTitle/componentTitle";
import { ExpandButton } from "../../../components/expandButton/expandButton";
import PropTypes from "prop-types";

/*
 * Chart component is a wrapper for plotly charts that handles the loading and error states
 * It adds the component title and expand behaviour
 */
export const Chart = ({
  icon,
  title,
  topRightContent,
  isLoading,
  missingData,
  children,
}) => {
  const [expanded, setExpanded] = useState(false);

  // Expanding is a CSS change, not a window resize, so the `useResizeHandler`
  // the Plotly children carry never fires on its own and the chart keeps its
  // old size. One synthetic resize event after the class flip makes every chart
  // re-measure. That is what `key={expanded}` used to achieve, by remounting the
  // whole subtree and wiping its state along the way (R1-20).
  useEffect(() => {
    window.dispatchEvent(new Event("resize"));
  }, [expanded]);

  return (
    // No `key={expanded}` here: changing a React key unmounts and remounts the
    // whole subtree, so expanding a chart threw away every bit of its child's
    // state (the colouring attribute, the selected plots, the hidden traces).
    // That was R1-20. Plotly re-measures on its own through `useResizeHandler`,
    // which every chart passes.
    <div className={`powerdash-component ${expanded ? "expanded" : ""}`}>
      <ComponentTitle
        title={missingData || isLoading ? "" : title}
        icon={icon}
        topRightContent={
          <>
            {topRightContent}
            <ExpandButton expanded={expanded} setExpanded={setExpanded} />
          </>
        }
      />
      {isLoading ? (
        <ComponentPlaceholder
          icon="fa-solid fa-spinner fa-spin"
          text="Data for this chart is loading, this may take a while"
        />
      ) : missingData ? (
        <ComponentPlaceholder icon="fa-solid fa-chart-area" />
      ) : (
        children
      )}
    </div>
  );
};

Chart.propTypes = {
  icon: PropTypes.string,
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  missingData: PropTypes.bool,
  title: PropTypes.node,
  topRightContent: PropTypes.node,
};
